import { Button, Form } from "antd";
import { useGetTypeList } from "features/master/use-cases/get-type";
import { useCreateMatrialDetails } from "features/material-details/use-cases/create-material";
import { useEffect, useState } from "react";

import { MatrialDetailsInfoFormItems } from "./matrial-info-form-items";

type MatrialDetailsModalViewProps = {
  onClose: () => void;
  matrialEditData?: any;
  form: any,
  setSelectedType: any,
  selectedType: any
};

export const MatrialDetailsModalView = ({
  onClose,
  matrialEditData,
  form,
  setSelectedType,
  selectedType
}: MatrialDetailsModalViewProps) => {
  const [validateTrigger, setValidateTrigger] = useState<("onSubmit" | "onChange")[]>(["onSubmit"]);
  const { isLoading, mutate } = useCreateMatrialDetails();
  const { data: typeList } = useGetTypeList("" as any);

    const formatText = (value: string) => {
    if (!value) return "";
        const trimmed = value.trim();
        
    return trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
  };

  const handleSubmit = (values: any) => {
    const isEdit = !!matrialEditData?.materialId;
    const payload: any = {
      flag: isEdit ? "update" : "insert",
      materialId: values.materialId, // keep original ID only in edit
      materialDetailId: matrialEditData?.materialDetailId,
      description: formatText(values.description),
      purity: +values.purity,
      bundleSize: +values.bundleSize,
      tonSize: +values.tonSize,
      bundleWeight: +values.bundleWeight,
      bundlePrice: +values.bundlePrice,
      isActive: values.status ?? true,
      IsApprovalReqired: values?.isVerification,
    };
    mutate(payload, { onSuccess: handleClose })
  };
  
  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  useEffect(() => {
    if (matrialEditData) {
      form.setFieldsValue(matrialEditData);
    } else {
      form.resetFields();
    }
  }, [matrialEditData, form]);

  return (
    <div className="popup">
      <div className="modal_head">
        <button onClick={handleClose} className="close-btn">
          &times;
        </button>
        <h4>{matrialEditData ? "Edit Material Detail" : "Add Material Detail"}</h4>
      </div>
      <div className="modal_body">
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          onFinishFailed={() => setValidateTrigger(["onChange"])}
          validateTrigger={validateTrigger}
          disabled={isLoading}
        >
          <MatrialDetailsInfoFormItems data={typeList} setSelectedType={setSelectedType}
            selectedType={selectedType} matrialEditData={matrialEditData}/>

          <div className="form-button">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              Save
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};
